var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',{attrs:{"fluid":""}},[_c('Header'),_c('Admintopbar',{attrs:{"breadcrumb":_vm.breadcrumb}}),_c('section',{staticClass:"mt-3"},[_c('mdb-row',[_c('mdb-col',{attrs:{"md":"12"}},[_c('checklist-creation-form',{on:{"save":(checklist) => _vm.$router.push({path: `/admin/checklist/edit/${checklist.id}`})}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }